import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';

import { MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';

type DeleteOption = {
  value: string;
  label: string;
  defaultChecked?: boolean; // Making defaultChecked optional
};

const getDeleteOptions = ({ hasTasks, isArchivedtoLibrary }) => {
  const deleteOptions: DeleteOption[] = [
    {
      value: '',
      label: 'Delete in Inbox only',
      defaultChecked: true,
    },
  ];

  if (isArchivedtoLibrary) {
    deleteOptions.push({
      value: 'library',
      label: 'Delete in Inbox and in Library',
    });
  }
  if (hasTasks) {
    deleteOptions.push({
      value: 'task',
      label: 'Delete in Inbox and in Task',
    });
  }

  if (isArchivedtoLibrary && hasTasks) {
    deleteOptions.push({
      value: 'all',
      label: 'Delete All Copies',
    });
  }

  return deleteOptions;
};

const ArchiveDocumentModal = (props) => {
  const { onClose, onRadioChange, onArchive, hasTasks, isArchivedtoLibrary, selected, subject } =
    props;
  const deleteOptions = getDeleteOptions({
    hasTasks,
    isArchivedtoLibrary,
  });
  const submitDisabled = selected === null;

  return (
    <ModalPopup
      id={'archive-document-modal'}
      title={`Delete this ${_.upperFirst(subject)} ?`}
      modalType={MODAL_TYPE.danger}
      onClose={onClose}
      onConfirm={onArchive}
      confirmBtn={{ label: 'Delete', disabled: submitDisabled }}
    >
      <p className={clsx('tw-text-cfo-black tw-leading-[25px]')}>
        We found this file in other modules, what do you want to do?
      </p>
      <div className={clsx('container--deleteOptions')}>
        {deleteOptions.map((deleteOption) => {
          return (
            <div key={`do_${deleteOption.value}`}>
              <label
                className={clsx(
                  'tw-flex tw-items-center',
                  // (!) is not removed here as it is to override the styles from vendor.css
                  'tw-text-cfo-black !tw-font-normal',
                  'tw-mb-[10px]'
                )}
              >
                <input
                  type="radio"
                  id="librayAndTask"
                  className={clsx(
                    // (!) is not removed here as it is to override the styles from vendor.css
                    '!tw-mt-0 !tw-mr-[10px]',
                    selected === deleteOption.value &&
                      'checked before:!tw-bg-cfo-black !tw-border-cfo-black'
                  )}
                  name="selector"
                  value={deleteOption.value}
                  onClick={onRadioChange}
                  defaultChecked={deleteOption.defaultChecked}
                />
                {deleteOption.label}
              </label>
            </div>
          );
        })}
      </div>
    </ModalPopup>
  );
};

export default ArchiveDocumentModal;
